import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { userDataReducer } from './user-reducer';

@NgModule({
  imports: [StoreModule.forFeature('userData', userDataReducer)],
})
export class UserStoreModule {}
